<template lang="html">
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">

    <g>
      <ellipse :style="{'fill': circleFill}" cx="255.499" cy="255.499" rx="249.283" ry="255.499"/>
    </g>

    <g transform="translate(100 100) scale(.6)">
      <path style="fill:#B3FFFF;" d="M512,86.225v339.56c0,24.904-20.265,45.169-45.169,45.169H45.309
      c-24.904,0-45.169-20.265-45.169-45.169V86.225c0-24.914,20.265-45.179,45.169-45.179h421.521C491.735,41.045,512,61.311,512,86.225
      z"/>
      <path style="fill:#51FAFF;" d="M512,86.225v339.56c0,24.904-20.265,45.169-45.169,45.169H256.07V41.045h210.761
      C491.735,41.045,512,61.311,512,86.225z"/>
      <path style="fill:#4BB9EC;" d="M511.86,170.445v-29.993H391.178V41.045h-29.993v99.407h-90.119V41.045h-29.993v99.407h-91.479
      V41.045h-29.993v99.407H0v29.993h119.602v66.774H0v29.993h119.602v71.313H0v29.993h119.602v102.436h29.993V368.519h91.479v102.436
      h29.993V368.519h90.119v102.436h29.993V368.519H511.86v-29.993H391.178v-71.313H511.86v-29.993H391.178v-66.774L511.86,170.445
      L511.86,170.445z M241.074,338.526h-91.479v-71.313h91.479V338.526z M241.074,237.219h-91.479v-66.774h91.479V237.219z
      M361.185,338.526h-90.119v-71.313h90.119L361.185,338.526L361.185,338.526z M361.185,237.219h-90.119v-66.774h90.119
      L361.185,237.219L361.185,237.219z"/>
      <path style="fill:#00ABE9;" d="M511.86,170.445v-29.993H391.178V41.045h-29.993v99.407h-90.119V41.045H255.93v429.909h15.136
      V368.519h90.119v102.436h29.993V368.519H511.86v-29.993H391.178v-71.313H511.86v-29.993H391.178v-66.774L511.86,170.445
      L511.86,170.445z M361.185,338.526h-90.119v-71.313h90.119L361.185,338.526L361.185,338.526z M361.185,237.219h-90.119v-66.774
      h90.119L361.185,237.219L361.185,237.219z"/>
      <g>
      <path style="fill:#7CC8F0;" d="M89.782,121.256H59.675c-8.282,0-14.996-6.714-14.996-14.996s6.714-14.996,14.996-14.996h30.107
      c8.282,0,14.996,6.714,14.996,14.996S98.065,121.256,89.782,121.256z"/>
      <path style="fill:#7CC8F0;" d="M210.389,121.256h-30.107c-8.282,0-14.996-6.714-14.996-14.996S172,91.263,180.282,91.263h30.107
      c8.282,0,14.996,6.714,14.996,14.996S218.671,121.256,210.389,121.256z"/>
      </g>
      <g>
      <path style="fill:#4BB9EC;" d="M331.36,121.256h-30.107c-8.282,0-14.996-6.714-14.996-14.996s6.714-14.996,14.996-14.996h30.107
      c8.282,0,14.996,6.714,14.996,14.996S339.642,121.256,331.36,121.256z"/>
      <path style="fill:#4BB9EC;" d="M451.402,121.256h-30.107c-8.282,0-14.996-6.714-14.996-14.996s6.714-14.996,14.996-14.996h30.107
      c8.282,0,14.996,6.714,14.996,14.996S459.684,121.256,451.402,121.256z"/>
      </g>
      <g>
      <path style="fill:#7CC8F0;" d="M89.782,218.825H59.675c-8.282,0-14.996-6.714-14.996-14.996s6.714-14.996,14.996-14.996h30.107
      c8.282,0,14.996,6.714,14.996,14.996S98.065,218.825,89.782,218.825z"/>
      <path style="fill:#7CC8F0;" d="M89.782,318.906H59.675c-8.282,0-14.996-6.714-14.996-14.996s6.714-14.996,14.996-14.996h30.107
      c8.282,0,14.996,6.714,14.996,14.996S98.065,318.906,89.782,318.906z"/>
      <path style="fill:#7CC8F0;" d="M89.782,420.775H59.675c-8.282,0-14.996-6.714-14.996-14.996c0-8.282,6.714-14.996,14.996-14.996
      h30.107c8.282,0,14.996,6.714,14.996,14.996C104.778,414.061,98.065,420.775,89.782,420.775z"/>
      <path style="fill:#7CC8F0;" d="M466.681,41.045H45.169C20.265,41.045,0,61.311,0,86.225v339.56
      c0,24.904,20.265,45.169,45.169,45.169h421.511c24.914,0,45.179-20.265,45.179-45.169V86.225
      C511.86,61.311,491.595,41.045,466.681,41.045z M481.867,425.785c0,8.368-6.808,15.176-15.186,15.176H45.169
      c-8.368,0-15.176-6.808-15.176-15.176V86.225c0-8.368,6.808-15.186,15.176-15.186h421.511c8.378,0,15.186,6.818,15.186,15.186
      L481.867,425.785L481.867,425.785z"/>
      </g>
      <path style="fill:#4BB9EC;" d="M511.86,86.225v339.56c0,24.904-20.265,45.169-45.179,45.169H256.07v-29.993h210.611
      c8.378,0,15.186-6.808,15.186-15.176V86.225c0-8.368-6.808-15.186-15.186-15.186H256.07V41.045h210.611
      C491.595,41.045,511.86,61.311,511.86,86.225z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ExcelSheet',
  props: {
    circleFill: {
      default: '#bdcdda'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/menu/ExcelSheet.vue